/*
 * General code
 */

export default function (app) {

    /*
     * Header items toggle active for mobile only
     * On desktops there should be hover
     */
    {
        let elements = document.querySelectorAll('body.is-mobile #header .header-item')
        elements.forEach((el, index, array) => {
            el.addEventListener('click', (event) => {
                // event.preventDefault()

                // Remove active class for all elements except current one
                array.forEach((el, indexInner) => {
                    if (indexInner !== index)
                        el.classList.remove('active')
                })

                el.classList.toggle('active')
            })
        })
    }

    /*
     * Toggle burger menu
     */
    {
        let burgerBtn = document.querySelector('#header #burger-btn')
        let burgerMenu = document.querySelector('#header #burger-menu')
        let body = document.querySelector('body')

        if(burgerBtn) {
            burgerBtn.addEventListener('click', (event) => {
                let areaExpanded = burgerMenu.getAttribute('aria-expanded') === 'true'

                burgerMenu.setAttribute('aria-expanded', !areaExpanded)

                if (areaExpanded) {
                    body.classList.remove('burger-open')
                    burgerBtn.classList.remove('active')
                } else {
                    body.classList.add('burger-open')
                    burgerBtn.classList.add('active')
                }
            })
        }
    }

    /*
     * Protect logout with CSRF
     */
    {
        $("#logout,#logout-m").each(function() {
            $(this).click(function(event) {
                event.preventDefault();

                $.ajax({
                    url: $(this).attr("href"),
                    headers: {
                        'X-CSRF-TOKEN': $("meta[name=csrf-token]").attr("content")
                    },
                    type: "DELETE",
                    complete: function (xhr, status) {
                        if (xhr.status === 200) {
                            window.location.href = xhr.responseJSON.redir
                        }
                    }
                })
            })
        })
    }

    /*
     * Toggle active class
     * Triggered by elements with class "toggle-active-class"
     */
    {

        let triggers = document.querySelectorAll('body.panel .toggle-active-class')
        let accordion = document.querySelectorAll('body.panel .accordion dl')

        const toggle  = (el) => {
            let panel = el.nextElementSibling;
            if(panel.scrollHeight) { // skip faq hidden accordions
                el.classList.toggle("active")
                panel.style.maxHeight = (panel.style.maxHeight) ? null : panel.scrollHeight + "px"
            }
            return el
        }

        for(const el of triggers) {

            // Toggle the element on click
            el.addEventListener('click', ()=>{toggle(el)})

            // Check if the element contains errors
            const withErrors = el.nextElementSibling.querySelectorAll('.form-field.with-error')

            // If element with errors
            if(withErrors.length > 0) {

                // Display the element
                el.click()

            }

        }

        // If we have an active accordion
        if(accordion.length > 0 && accordion[0].dataset.active) {

            // Get the active element id
            const activeElementId = accordion[0].dataset.active
            const activeElement = document.querySelectorAll('body.panel .accordion dt[data-id="' + activeElementId + '"]')

            // Click on the element
            if(activeElement.length > 0) activeElement[0].click()

            // Scroll to element
            document.getElementById('main').scrollTop = activeElement[0].offsetTop

        }

    }

    /*
     *  Fixing for html anchor in url to work with parameters
     */
    window.onload = function() {
            if(window.location.hash) {
            const el = document.getElementById(window.location.hash.substring(1));
            el.scrollIntoView(true);
        }
    }

}
